import { createContext, useContext } from "react";

// Store currency is fixed to INR (₹). Prices are entered in INR and displayed in INR everywhere.
const CURRENCY = "inr";
const SYMBOL = "₹";

const CurrencyContext = createContext({
  currency: CURRENCY,
  symbol: SYMBOL,
  formatPrice: (p) => `${SYMBOL}${Number(p ?? 0).toFixed(2)}`,
});

export function CurrencyProvider({ children }) {
  const formatPrice = (amount) => `${SYMBOL}${Number(amount ?? 0).toFixed(2)}`;
  return (
    <CurrencyContext.Provider value={{ currency: CURRENCY, symbol: SYMBOL, formatPrice }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
